export const socialsData = {
    github: 'https://github.com/farhan-sadiq-mahi',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/md-farhan-sadiq/',
    instagram: '',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/',
    reddit: '',
    blogger: '',
    medium: '',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}